import { useState, useEffect, useCallback } from "react";
import apiClient from "../api/apiClient";
import errorMessage from "./apiError";

const useConfig = (mode) => {
    const [isOpen, setisOpen] = useState(false);
    const [isLoading, setisLoading] = useState(true);
    const [config, setConfig] = useState({});
    const [error, setError] = useState("");

    const fetchData = useCallback(() => {
        setisLoading(true);
        setError("");
        apiClient
            .get("config/")
            .then((res) => {
                if (mode === "ambassador") {
                    setisOpen(res.data.isAmbassadorRegOpen);
                } else if (mode === "officer") {
                    setisOpen(res.data.isOfficerRegOpen);
                } else if (mode === "team") {
                    setisOpen(res.data.isTeamRegOpen);
                }
                setConfig({
                    foodFee: res.data.foodFee,
                    accommodationFee: res.data.accommodationFee,
                    isFoodRegOpen: res.data.isFoodRegOpen,
                    isAccommodationRegOpen: res.data.isAccommodationRegOpen,
                });
            })
            .catch((err) => {
                // Without this the rejection is unhandled and isOpen stays
                // false, so the page claims registration is closed when the
                // truth is that we never reached the server.
                setError(errorMessage(err));
            })
            .finally(() => setisLoading(false));
    }, [mode]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        isOpen,
        config,
        isLoading,
        error,
        retry: fetchData,
    };
};

export default useConfig;
